/**
 * canMixin — global Vue mixin for permission-based UI gating.
 *
 * Usage in any component:
 *   this.can('subscriptions.create')           → boolean
 *   v-if="can('subscriptions.view_financials')"
 *
 * Admin and owner roles bypass all permission checks so that newly-added
 * permissions that haven't been re-seeded yet don't accidentally hide UI for
 * superusers. All other roles fall through to a direct permission-name lookup.
 */

const SUPER_ROLES  = ['Admin', 'owner'];
const TENANT_GUARDS = ['web', 'sanctum'];

export default {
  methods: {
    can(permissionName) {
      const user  = this.$store.state.userDetails;
      const roles = user?.roles ?? [];

      if (roles.some(r => SUPER_ROLES.includes(r.name) && TENANT_GUARDS.includes(r.guard_name))) {
        return true;
      }

      const permissions = user?.permissions ?? [];
      return permissions.some(p => p.name === permissionName);
    },
  },
};
